import { http } from "@canvas/api";
import store from "@/store";

export interface BouncerUserGetReq {
  endpoint: "bouncer.v2.users.:user_id";
  user_id: string;
  query?: string;
}

export interface BouncerUserGetRes {
  id: string | number;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  display_name: string;
  type: string;
}

export function get(req: BouncerUserGetReq): Promise<BouncerUserGetRes> {
  const endpoint = store.state.appModule.config && store.state.appModule.config.serviceConfigMap.bouncer;
  return http
    .GET(`/${endpoint}/v2/users/${req.user_id}?${req.query}`)
    .then((response: BouncerUserGetRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
